import { CandidateInvitationStats, CandidateProfile } from "../../Candidate/Types/CandidateType";
import { PaginationResponse, PagedStatsResponse } from "../../Shared/Pagination/PaginationResponse";
import { getApi, getApiById, getApiByWithoutId, getApiListById, postApi, postApiPagination, putApi, putApiWithoutId, deleteApi } from "../../Shared/Services/RestService";
import { RecruiterResponse, RecruiterStats } from "../Types/RecruiterTypes";


export interface RecruiterFilters {
  search?: string;
  role?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
}

/**
 * Filtered + paginated company recruiter listing for the manage-recruiter table.
 * `userId` is the current recruiter's user id; the backend resolves the company from it.
 */
export const getCompanyRecruitersFiltered = (
  userId: string,
  filters: RecruiterFilters = {},
  page: number = 0,
  size?: number
) => {
  const params: any = {
    page,
  };

  if (filters.search) params.search = filters.search;
  if (filters.role && filters.role !== "ALL") params.role = filters.role;
  if (filters.status && filters.status !== "ALL") params.status = filters.status;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  if (size !== undefined) params.size = size;

  return getApi<PagedStatsResponse<RecruiterResponse, RecruiterStats>>(
    `/recruiter/company/${userId}/filtered`,
    params
  );
};


export const getAllRecruiters = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<CandidateProfile[]>("/candidates", params);
};

export const getAllRecruitersByCompanyId = (id: string, page: number =0 ,size?: number ) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListById<PaginationResponse<RecruiterResponse>>("/recruiter/company", id, params);
};

export const createRecruiter = (payload: any) => {
  return postApi<RecruiterResponse>("/recruiter/company-recruiter", payload);
};

export const updateCandidate = (payload: any, id: string) => {
  return putApi<CandidateProfile | null>("/candidates", id, payload);
};


export const getInvitationStatsByCandidiateId = (id: string ) => {
  return getApiById<CandidateInvitationStats | null>("/invitations/count", id);
};



export const getAllCandidateStatsByStatus = (payload: any, page: number =0 ,size?: number ) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return postApiPagination<PaginationResponse<CandidateProfile>>("/candidates/by-status", payload, params);
};


export const getRecuiterById = () => {
  return getApiByWithoutId<RecruiterResponse | null>("/recruiter/me");
};

export const updateRecuiterById = (payload:any) => {
  return putApiWithoutId<RecruiterResponse | null>("/recruiter/me", payload);
};

export const updateRecruiterByCompanyAdmin = (userId: string, payload: any) => {
  return putApi<RecruiterResponse>("/recruiter", userId, payload);
};

export const deleteRecruiter = (id: string) => {
  return deleteApi<null>("/recruiter", id);
};
